export default __webpack_public_path__ + "static/media/logoAskQuestion.590b82cf.svg";